import React, { useEffect, useState } from "react";
import styled from "styled-components";
import SearchMenu from "../GenericComponents/SearchMenu";
import { RotatingLines } from "react-loader-spinner";
import { filterConversations } from "../../Helpers/filters/filterConversations";
import { colors } from "../../Assets/styles/colors";
import ConferenceListElement from "./ConferenceListElement";
import InfiniteScroll from "react-infinite-scroll-component";
import { useGenericComponentsStateService } from "../../Context/GenericComponentsStateContext";
import EmptyConferenceList from "./EmptyConferenceList";

const ConferenceList = ({
  conferences,
  handleJoinConference,
  selectedConference,
  handleSelectConference,
  loadConferences,
}) => {
  const [searchInput, setSearchInput] = useState("");
  const [tick, setTick] = useState(0);
  const { meetingListSpinner } = useGenericComponentsStateService();

  useEffect(() => {
    loadConferences();
  }, []);

  // Single interval to trigger time-based UI updates for all list elements
  // Only ticks when the browser tab is visible
  useEffect(() => {
    const interval = setInterval(() => {
      if (!document.hidden) {
        setTick((t) => t + 1);
      }
    }, 60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <ChatsList>
      <div style={{ padding: "0 16px" }}>
        <SearchMenu value={searchInput} setvalue={setSearchInput} />
      </div>

      {!meetingListSpinner ? (
        conferences.length > 0 ? (
          <Scrollwrapper id={"meetingsList"}>
            <InfiniteScroll
              dataLength={conferences.length}
              scrollableTarget="meetingsList"
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "5px",
                width: "100%",
              }}
            >
              {filterConversations(conferences, searchInput).map((conference) => (
                <ConferenceListElement
                  key={conference.id}
                  data={conference}
                  selected={selectedConference?.id === conference.id}
                  handleJoinConference={handleJoinConference}
                  handleSelectConference={handleSelectConference}
                  tick={tick}
                />
              ))}
            </InfiniteScroll>
          </Scrollwrapper>
        ) : (
          <EmptyConferenceList />
        )
      ) : (
        <SpinnerWrapper>
          <RotatingLines
            strokeColor={colors.purple}
            strokeWidth={3}
            animationDuration="0.75"
            width={50}
            visible={true}
          />
        </SpinnerWrapper>
      )}
    </ChatsList>
  );
};

export default ConferenceList;

const ChatsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
  width: 100%;
  overflow: hidden;
  padding: 16px 0;
`;
const SpinnerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;
const Scrollwrapper = styled.div`
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 100%;
  position: relative;
`;
